import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueMaterial from 'vue-material';

import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import i18n from './i18n';
import head from './head';

import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default-dark.css';
import './assets/scss/app.scss';
import firebase from './firebase';


Vue.use(VueMaterial);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.config.productionTip = false;

let app;
firebase.auth.onAuthStateChanged(() => {
    if (!app) {
        app = new Vue({
            router,
            store,
            i18n,
            head,
            render: (h) => h(App)
        }).$mount('#app');
    }
});
